<div class="container highlight-cursor">

  <div class="row">
    <div class="col-6">

      <wim-suggestion-input #employeeSuggestionInput
                            [label]="'EMPLOYEE_OR_WAREHOUSE' | translate"
                            [fetchSuggestions]="employeeFetchSuggestions"
                            [displayFn]="DisplayHelper.locationDisplayFn"
                            (onOptionSelected)="onEmployeeSelected($event)"/>
    </div>

    <div class="col-1">
      <img class="img-defaultphoto-icon iconw70xh70" id="mobilelocationbooking_employee_icon" src="">
    </div>
  </div>

  <div class="row">
    <div class="col-6">

      <wim-suggestion-input #mobileLocationSuggestionInput
                            [label]="'MOBILE_LOCATION.MOBILE_LOCATION' | translate"
                            [fetchSuggestions]="mobileLocationFetchSuggestions"
                            [displayFn]="DisplayHelper.locationDisplayFn"
                            (onOptionSelected)="onMobileLocationSelected($event)"/>

    </div>
    <div class="col-1">
      <img class="img-defaultphoto-icon iconw70xh70" id="mobilelocationbooking_mobilelocation_icon" src="">
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <wim-suggestion-input id="toProjectSuggestionInput"
                            #toProjectSuggestionInput
                            [label]="'PROJECT.TO_PROJECT' | translate"
                            [fetchSuggestions]="toProjectFetchSuggestions"
                            [displayFn]="DisplayHelper.projectDisplayFn"
                            [optional]="true"
                            (onOptionSelected)="onToProjectSelected($event)"/>
    </div>
  </div>

  <div class="col-4 my-2">
    <button mat-raised-button
            color="primary"
            class="me-2"
            [disabled]="!isBookingPossible()"
            (click)="onBooking()">
      {{ 'SAVE.SAVE' | translate }}
    </button>

    <button mat-raised-button (click)="onCancel()">
      {{ 'CANCEL' | translate }}
    </button>
  </div>
</div>
